import { actions } from "app/containers/Features/containers/Boards/containers/Tickets/TicketFields/redux/slice";
import { useDispatch } from "react-redux";
import {
  ITicketResponse,
  ITicketTagsResponse,
  TicketTagsActionsEnum,
} from "../../Boards/containers/Tickets/TicketFields/types";
import { EffortEstimatedPayload } from "app/containers/Features/types";

type TicketId = string | string[];
type UpdateCallback = () => void;

interface Props {
  projectId: string;
  hideToast?: boolean;
}

export const useTicketUpdateActions = ({
  projectId,
  hideToast: hideToastByDefault,
}: Props) => {
  const dispatch = useDispatch();

  const getFormData = (id: string, ticketIds: TicketId): ITicketResponse => ({
    id,
    projectId,
    ticketIds: Array.isArray(ticketIds) ? ticketIds : [ticketIds],
  });
  const getTagsFormData = (
    tags: string[],
    tagActions: TicketTagsActionsEnum,
    ticketIds: string[],
  ): ITicketTagsResponse => ({
    tags,
    projectId,
    tagActions,
    ticketIds,
  });

  const assigneeUpdate = (
    id: string,
    ticketIds: TicketId,
    callback: UpdateCallback = () => {},
    hideToast?: boolean,
  ) => {
    dispatch(
      actions.assigneeUpdate({
        hideToast: hideToast ?? hideToastByDefault,
        data: getFormData(id, ticketIds),
        callback,
      }),
    );
  };
  const statusUpdate = (
    id: string,
    ticketIds: TicketId,
    callback: UpdateCallback = () => {},
    hideToast?: boolean,
  ) => {
    dispatch(
      actions.statusUpdate({
        hideToast: hideToastByDefault,
        data: getFormData(id, ticketIds),
        callback,
      }),
    );
  };
  const ticketTypeUpdate = (
    id: string,
    ticketIds: TicketId,
    callback: UpdateCallback = () => {},
    hideToast?: boolean,
  ) => {
    dispatch(
      actions.ticketTypeUpdate({
        hideToast: hideToastByDefault,
        data: getFormData(id, ticketIds),
        callback,
      }),
    );
  };
  const priorityUpdate = (
    id: string,
    ticketIds: TicketId,
    callback: UpdateCallback = () => {},
    hideToast?: boolean,
  ) => {
    dispatch(
      actions.priorityUpdate({
        hideToast: hideToastByDefault,
        data: getFormData(id, ticketIds),
        callback,
      }),
    );
  };
  const dueDateUpdate = (
    id: string,
    ticketIds: TicketId,
    callback: UpdateCallback = () => {},
    hideToast?: boolean,
  ) => {
    dispatch(
      actions.dueDateUpdate({
        hideToast: hideToastByDefault,
        data: getFormData(id, ticketIds),
        callback,
      }),
    );
  };
  const ticketNameUpdate = (
    id: string,
    ticketIds: TicketId,
    callback: UpdateCallback = () => {},
  ) => {
    dispatch(
      actions.ticketNameUpdate({
        data: getFormData(id, ticketIds),
        callback,
      }),
    );
  };
  const ticketTagsUpdate = (
    tags: string[],
    ticketIds: string[],
    action: TicketTagsActionsEnum,
    callback: UpdateCallback = () => {},
    hideToast?: boolean,
  ) => {
    dispatch(
      actions.ticketTagsUpdate({
        hideToast: hideToastByDefault,
        data: getTagsFormData(tags, action, ticketIds),
        callback,
      }),
    );
  };
  const effortEstimationUpdate = (
    effortEstimated: EffortEstimatedPayload,
    ticketId: string,
    callback: UpdateCallback = () => {},
  ) => {
    dispatch(
      actions.effortEstimationUpdate({
        effortEstimated: effortEstimated,
        projectId: projectId,
        ticketId: ticketId,
        callback: callback ?? (() => {}),
      }),
    );
  };

  return {
    assigneeUpdate,
    statusUpdate,
    ticketTypeUpdate,
    priorityUpdate,
    dueDateUpdate,
    ticketNameUpdate,
    ticketTagsUpdate,
    effortEstimationUpdate,
  };
};
